import { get, post } from '../utils/api';

export const getGroups = () => get(`groups`);

export const createGroup = (payload) => post('groups', payload);